import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { AppService } from '../../../../../../app/app.service';
import {
  CurrentSelection, Customer, Equipment, Family, JobSite, Make,
  Model, SearchItem, SelectionLists
} from '../../../../../../app/entities';
import { SharedService } from '../../../../../../app/shared/services/SharedService';
import { TranslateService } from '../../../../../../app/translate';
import { InterpretationService } from '../../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ManageComponentsService } from '../../../../../../app/modules/manage-components/manage-components.service';
import { ComponentList, ComponentType } from '../../../../../../app/modules/manage-components/manage-components.model';
import { SetupModelsService } from '../../../../../../app/modules/setup-models/setup-models.service';
import { ServiceCycleVM, UnitNumberVm } from '../../../../../../app/modules/setup-models/setup-models.model';
import { ForecastWearConfigurationViewModel } from '../../../models/interpretation.model';

@Component({
  selector: 'app-forecast-configuraration',
  templateUrl: './forecast-configuraration.component.html',
  styleUrls: ['./forecast-configuraration.component.scss']
})
export class ForecastConfigurarationComponent implements OnInit, AfterViewInit {
  customerCtrl: FormControl;
  jobsiteCtrl: FormControl;
  equipmentCtrl: FormControl;
  selectedComponentType: number = 0;
  familyCtrl: FormControl;
  makeCtrl: FormControl;
  modelCtrl: FormControl;
  filteredCustomers: Observable<Customer[]>;
  filteredJobsites: Observable<JobSite[]>;
  filteredMakes: Observable<Make[]>;
  filteredModels: Observable<Model[]>;
  userLanguage = 'english';
  make_auto: number = -1;
  CustomerId: number;
  JobsiteId: number;
  model_auto: number = -1;
  unitnumber: string = '';
  @ViewChild('customerAutoCompleteInput', { read: MatAutocompleteTrigger })
  customerTrigger: MatAutocompleteTrigger;
  @ViewChild('jobSiteAutoCompleteInput', { read: MatAutocompleteTrigger })
  jobSiteTrigger: MatAutocompleteTrigger;
  @ViewChild('equipmentAutoCompleteInput', { read: MatAutocompleteTrigger })
  equipmentTrigger: MatAutocompleteTrigger;
  @ViewChild('makeAutoCompleteInput', { read: MatAutocompleteTrigger })
  makeTrigger: MatAutocompleteTrigger;
  @ViewChild('familyAutoCompleteInput', { read: MatAutocompleteTrigger })
  familyTrigger: MatAutocompleteTrigger;
  @ViewChild('modelAutoCompleteInput', { read: MatAutocompleteTrigger })
  modelTrigger: MatAutocompleteTrigger;
  @ViewChild('examinerAutoCompleteInput', { read: MatAutocompleteTrigger })
  examinerTrigger: MatAutocompleteTrigger;
  @ViewChild('dealerAutoCompleteInput', { read: MatAutocompleteTrigger })
  dealerTrigger: MatAutocompleteTrigger;
  selectedUnitNumber: string;
  Flag: number;
  filteredEquipments: Observable<Equipment[]>;
  modelName: string;
  wearid: number = 0;
  customerid: number = 0;
  jobsiteid: number = 0;
  makeid: number = 0;
  modelid: number = 0;
  selectedBaseModel: number = 0;
  compartid_auto: string;
  progid: string;
  parentCompartID: number;
  public ComponentId: string;
  public ComponentDescription: string;
  public ComponentMake: string;
  public EquipModel: string;
  public EquipMake: string;
  public partNo: string;
  public componentName: string;
  public comSubType: number
  ComponentList: ComponentList[] = []
  ComponentTypeDesc: number;
  ComponentType: string;
  numbers: number[] = Array.from({ length: 8 }, (_, i) => i + 1);
  Position: number;
  componentTypeId: number;
  ForecastWearConfigurationViewModel: ForecastWearConfigurationViewModel;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private _dialog: MatDialog, public _modelService: SetupModelsService,
    public _componentservice: ManageComponentsService, public dialogRef: MatDialogRef<ForecastConfigurarationComponent>, private _notification: NotificationsService, private _interp: InterpretationService, private _translate: TranslateService, private _appService: AppService, private _sharedService: SharedService,) {

    this.customerCtrl = new FormControl();
    this.jobsiteCtrl = new FormControl();
    this.equipmentCtrl = new FormControl();
    this.familyCtrl = new FormControl();
    this.makeCtrl = new FormControl();
    this.modelCtrl = new FormControl();
  }

  ngOnInit(): void {
    this.ForecastWearConfigurationViewModel = this.data.Item;

    if (this.ForecastWearConfigurationViewModel != null) {
      this.JobsiteId = this.ForecastWearConfigurationViewModel.JobsiteId
      this.make_auto = this.ForecastWearConfigurationViewModel.MakeId;
      this.CustomerId = this.ForecastWearConfigurationViewModel.CustomerId;
      this.selectedBaseModel = this.ForecastWearConfigurationViewModel.ModelId;
      this.selectedUnitNumber = this.ForecastWearConfigurationViewModel.UnitNumber;
      this.loadUnitNumber();
    } else {
      this.JobsiteId = this.data.jobsiteid
      this.make_auto = this.data.makeid;
      this.CustomerId = this.data.customerid;
      this.selectedBaseModel = this.data.modelid;
      //this.selectedUnitNumber = this.data.UnitNumber;
      this.loadUnitNumber();
    }

    this.Flag = this.data.Flag;
    this.wearid = this.data.WearId;
    this.modelName = this.data.modelName;
    if (this.Flag == 2) {
      this.getComponentType();
    }
    // this.modelCtrl.setValue(this.ForecastWearConfigurationViewModel.ModelId)

    this.loadBaseModelList()
    this._appService.getCustomerListForSelection(1, 10000).subscribe(result => {
      this.selectionLists.customerList = result; this.internalLimitedCustomers = result; this.customerCtrl.reset();

      if (this.CustomerId > 0) {
        const customerName = this.selectionLists.customerList.find(x => x.Id == this.CustomerId).Title;
        this.customerCtrl.setValue(this.CustomerId);
        this.pushMultipleSelection(1, this.CustomerId, customerName);
        // this.multipleSelections.find(x => x.Id == 1).SearchId=this.ForecastWearConfigurationViewModel.CustomerId;
      }



      this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => {

        this.selectionLists.jobSiteList = result;
        this.internalLimitedJobSites = result;
        this.jobsiteCtrl.reset();
        if (this.JobsiteId > 0) {
          const jobsiteName = this.selectionLists.jobSiteList.find(x => x.Id == this.JobsiteId).Title;
          this.jobsiteCtrl.setValue(jobsiteName);
          this.pushMultipleSelection(2, this.JobsiteId, jobsiteName);
          // this.multipleSelections.find(x => x.Id == 2).SearchId= this.ForecastWearConfigurationViewModel.JobsiteId
        }


        this._appService.getMakeListForSelection(1, 10000).subscribe(result => {
          this.selectionLists.makeList = this.filterMakeModelFamilyForExistingOnly ? result.filter(m => m.ExistingCount > 0) : result; this.makeCtrl.reset();
          if (this.make_auto > 0) {
            const makeName = this.selectionLists.makeList.find(x => x.Id == this.make_auto).Title;
            this.makeCtrl.setValue(makeName);
            this.pushMultipleSelection(5, this.make_auto, makeName);

            //  this.multipleSelections.find(x => x.Id == 5).SearchId=this.ForecastWearConfigurationViewModel.MakeId;
          }

        });
      });


    });
    this._appService.getFamilyList('', '').subscribe(result => {
      this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    });

    this.filteredCustomers =
      this.customerCtrl.valueChanges
        .startWith(null)
        .map(customerInput => customerInput ? this.filterCustomers(customerInput) : this.resetCustomer());

    this.filteredJobsites = this.jobsiteCtrl.valueChanges
      .startWith(null)
      .map(jobsiteInput => jobsiteInput ? this.filterJobsites(jobsiteInput) : this.resetJobsite());

    this.filteredFamilies =
      this.familyCtrl.valueChanges
        .startWith(null)
        .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());
    this.filteredMakes =
      this.makeCtrl.valueChanges
        .startWith(null)
        .map(makeInput => makeInput ? this.filterMakes(makeInput) : this.resetMake());
    this.filteredModels =
      this.modelCtrl.valueChanges
        .startWith(null)
        .map(modelInput => modelInput ? this.filterModels(modelInput) : this.resetModel());



  }
  ngAfterViewInit(): void {
    // Prevent autocomplete dropdowns from auto-opening when dialog autofocus lands on a field.
    setTimeout(() => {
      this.customerTrigger?.closePanel();
      this.jobSiteTrigger?.closePanel();
      this.makeTrigger?.closePanel();
    });
  }
  resetModel(): Model[] {
    this.currentSelection.model = new Model();


    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
      return this.selectionLists.modelList.filter(model =>
        this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model =>
        this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);


    return this.selectionLists.modelList.filter(model =>
      this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
      && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);
  }

  resetCustomer(): Customer[] {
    // console.log('resetCustomer');
    this.currentSelection.customer = new Customer();
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);
    this.jobsiteCtrl.reset();

    // return this.selectionLists.customerList.filter(cust =>
    //     (this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr.toLowerCase() === cust.Title.toLowerCase())) < 0)
    // );

    if (this.multipleSelections.filter(m => m.Id === 21).length === 0)
      return this.selectionLists.customerList.filter(cust => this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0);

    if (this.multipleSelections.filter(m => m.Id === 21).length > 0)
      return this.selectionLists.customerList.filter(cust =>
        this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);

    return this.selectionLists.customerList.filter(cust =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);


  }
  resetMake(): Make[] {
    this.currentSelection.make = new Make();
    if (!this.selectionLists.makeList) return [];

    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.modelCtrl.reset();
    return this.selectionLists.makeList.filter(make =>
      (this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === make.Id || m.SearchStr.toLowerCase() === make.Title.toLowerCase())) < 0)
    );

  }

  filterModels(userText: any) {
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      );

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);


    return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
      && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
      && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

  }
  filterMakes(userText: any) {
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    return this.selectionLists.makeList.filter(make =>
      (make.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0)
    );
  }
  internalLimitedJobSites: JobSite[];
  internalLimitedEquipments: Equipment[];
  internalLimitedModels: Model[];
  internalLimitedCustomers: Customer[];
  baseModelList: ServiceCycleVM[] = []
  UnitNumberVm: UnitNumberVm[] = [];
  filterMakeModelFamilyForExistingOnly = true;
  customerSelected(selected, input) {
    this.selectedJobsiteForInput.CustomerId = selected.option.value.Id
    this.currentSelection.customer.Id = selected.option.value.Id;
    this.currentSelection.customer.Title = selected.option.value.Title;
    //fleet configuration filter
    this.JobSiteforFleetconfiguration.CustomerId = selected.option.value.Id;
    //this._share
    // 
    // dService.setCustomerInfo(this.JobSiteforFleetconfiguration);
    this.pushMultipleSelection(1, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);

    this.customerCtrl.reset();
    this.customerCtrl.setValue(selected.option.value.Title)
  }
  multipleSelections: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: 'Evaluation X' }];

  selectionLists: SelectionLists = new SelectionLists();
  selectedJobsiteForInput: JobSite = new JobSite();
  currentSelection: CurrentSelection = new CurrentSelection();
  JobSiteforFleetconfiguration: JobSite = new JobSite()
  focus(item) {
    switch (item) {
      case 1:
        this.customerTrigger.openPanel();
        break;
      case 2:
        this.jobSiteTrigger.openPanel();
        break;
      case 3:
        this.equipmentTrigger.openPanel();
        break;
      case 4:
        this.familyTrigger.openPanel();
        break;
      case 5:
        this.makeTrigger.openPanel();
        break;
      case 6:
        this.modelTrigger.openPanel();
        break;
      case 20:
        this.examinerTrigger.openPanel();
        break;
      case 21:
        this.dealerTrigger.openPanel();
        break;
    }


  }
  filteredFamilies: Observable<Family[]>;
  pushMultipleSelection(itemId: number, searchId: number, searchText: string): void {

    if ((searchId === 0 && searchText.length === 0))
      return;
    console.log('itemId ' + itemId + '  search Id ' + searchId + ' searvh text ' + searchText)
    const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
    if (!currentSearchItem) return;

    // If the item isn't a date
    if (itemId !== 12 && itemId !== 13 && itemId !== 22 && itemId !== 23) {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId && (m.SearchId === searchId || m.SearchStr.toLowerCase() === searchText.toLowerCase()));
      if (index >= 0 && itemId !== 20) return;
    } else if (itemId == 22) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 22);
    }
    else if (itemId == 23) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 23);
    }
    else {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId);
      this.multipleSelections.splice(index, 1);
    }
    const item = new SearchItem();
    item.Id = itemId; item.SearchId = searchId; item.SearchStr = searchText; item.Title = searchText;

    if (itemId == 1) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 2) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 4) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 5) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    }
    else {
      this.multipleSelections.push(item);
    }


    console.log("this.multiple__", this.multipleSelections, item)
  }
  jobsiteSelected(selected, input) {
    this.selectedJobsiteForInput.Id = selected.option.value.Id
    this.currentSelection.jobSite.Id = selected.option.value.Id;
    this.currentSelection.jobSite.Title = selected.option.value.Title;
    this.pushMultipleSelection(2, selected.option.value.Id, selected.option.value.Title);
    this.JobSiteforFleetconfiguration.Id = selected.option.value.Id
    this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);

    this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(equipment =>
      this.multipleSelections.findIndex(m => m.Id === 2 && (equipment.JobSiteId === m.SearchId)) >= 0);
    this.filteredEquipments = Observable.of(this.internalLimitedEquipments);


    var customerData = this.multipleSelections.find(x => x.Id == 1);
    let customerid = 0;
    if (customerData != null) {
      customerid = customerData.SearchId;
    }

    var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
    let jobsiteid = 0;
    if (jobSiteData != null) {
      jobsiteid = jobSiteData.SearchId;
    }

    this._appService.getFamilyList(customerid.toString(), jobsiteid.toString()).subscribe(result => {
      this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    });

    this.filteredFamilies =
      this.familyCtrl.valueChanges
        .startWith(null)
        .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());

    this.jobsiteCtrl.reset();
    this.jobsiteCtrl.setValue(selected.option.value.Title);
  }

  resetFamily(): Family[] {
    // console.log('resetFamily', this.selectionLists.familyList);
    this.currentSelection.family = new Family();
    if (!this.selectionLists.familyList) return [];

    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.modelCtrl.reset();
    return this.selectionLists.familyList.filter(family =>
      (this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === family.Id || m.SearchStr.toLowerCase() === family.Title.toLowerCase())) < 0)
    );
  }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  resetJobsite(): JobSite[] {
    // console.log('resetJobsite', this.internalLimitedJobSites);
    this.currentSelection.jobSite = new JobSite();
    if (!this.internalLimitedJobSites) return [];

    this.equipmentCtrl.reset();
    return this.internalLimitedJobSites.filter(jobsite =>
      (this.multipleSelections.findIndex(m => m.Id === 2 && (m.SearchId === jobsite.Id || m.SearchStr.toLowerCase() === jobsite.Title.toLowerCase())) < 0)
    );
  }

  makeSelected(selected, input) {


    this.currentSelection.make.Id = selected.option.value.Id;
    this.currentSelection.make.Title = selected.option.value.Title;

    this.pushMultipleSelection(5, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 4).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.makeCtrl.reset();
    this.makeCtrl.setValue(selected.option.value.Title)
  }
  separatorKeysCodes: number[] = [ENTER, COMMA];
  getPushedSelections(itemId): SearchItem[] {
    let arr = this.multipleSelections.filter(m => m.Id === itemId);

    return arr
  }
  modelDisplayMapper(model: Model) {
    return model ? model.Title : model;
  }
  modelSelected(selected, input) {

    if (input)
      input.value = '';
    this.currentSelection.model.Id = selected.option.value.Id;
    this.currentSelection.model.Title = selected.option.value.Title;
    this.pushMultipleSelection(6, selected.option.value.Id, selected.option.value.Title);
    this.modelCtrl.reset();
  }

  filterFamilies(userText: any) {
    // console.log('filterFamilies', this.selectionLists.familyList);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    return this.selectionLists.familyList.filter(family =>
      family.Title.toLowerCase().indexOf(txt.toLowerCase())
    );
  }
  filterCustomers(userText: any) {
    // console.log('filterCustomers', userText);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.selectionLists.customerList.filter(cust => cust.Id == userText);
  }
  filterJobsites(userText: any) {
    // console.log('filterJobsites', userText);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.internalLimitedJobSites.filter(jobsite =>
      jobsite.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
    );
  }
  resetFields() {
    this.customerCtrl.reset();
    this.jobsiteCtrl.reset();
    this.makeCtrl.reset();
    this.modelCtrl.reset();
    this.familyCtrl.reset();
    this.multipleSelections = [];
    //this.selectedModel = [];
    // this.IsTableShow = false;
    this._appService.getFamilyList('', '').subscribe(result => {
      this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    });

    this.filteredFamilies =
      this.familyCtrl.valueChanges
        .startWith(null)
        .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());
  }


  SaveForecastConfigurationData() {
    this.CustomerId = this.multipleSelections.find(x => x.Id == 1).SearchId;
    var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
    if (jobSiteData != null) {
      if (this.jobsiteCtrl.value != '') {
        this.JobsiteId = jobSiteData.SearchId;
      }
    }
    var makeData = this.multipleSelections.find(x => x.Id == 5);
    if (makeData != null) {
      if (this.makeCtrl.value != '') {
        this.make_auto = makeData.SearchId;
      }
    }
    if (this.CustomerId > 0) {
      if (this.JobsiteId > 0) {
        if (this.make_auto > 0) {
          if (this.selectedBaseModel > 0) {
            let WearId = 0;
            if (this.ForecastWearConfigurationViewModel != null) {
              WearId = this.ForecastWearConfigurationViewModel.WearRateId;
            }
            this.unitnumber = this.selectedUnitNumber
            this._interp.SaveForecastConfiguaration(this.CustomerId, this.JobsiteId, this.make_auto, this.selectedBaseModel, this.unitnumber, WearId).subscribe(result => {
              if (result == 1) {
                this._notification.success('Data Saved Successfully.');
              }
            })
          } else {
            this._notification.warn('Please Select Model')
          }
        } else {
          this._notification.warn('Please Select Make')
        }
      } else {
        this._notification.warn('Please Select jobsite')
      }
    } else {
      this._notification.warn('Please Select Customer')
    }
  }

  changeComponentType(event: any) {
    this.ComponentType = event.value;//this.componentTypeList.find(x=>x.Id==event.value).Title ;
    this.componentTypeId = this.componentTypeList.find(x => x.Title == event.value).Id;
    this.GetComponentListForGrid();
  }

  GetComponentListForGrid() {
    this._componentservice.getAllComponentList(this.progid, this.ComponentId, this.ComponentDescription, this.ComponentType, this.EquipMake,
      this.ComponentMake, this.modelName,null).subscribe(result => {
        console.log("Result", result)
        this.ComponentList = result;
      });

  }
  componentTypeList: ComponentType[] = [];
  getComponentType() {
    this._componentservice.getComponentType().subscribe(result => {
      this.componentTypeList = result;
    })
  }

  SaveComponentType() {
    const COmpartTypeId = this.componentTypeList.find(x => x.Title == this.ComponentType).Id;
    this._interp.SaveForecastComponentConfiguaration(this.wearid, this.ComponentTypeDesc, COmpartTypeId, this.Position).subscribe(result => {
      if (result == 1) {
        this._notification.success('Data Saved Successfully.');
      }
    })
  }
  onNoClick(Value) {
    this.dialogRef.close(Value);
  }

  // electedBaseModel: number;
  loadBaseModelList() {
    this._modelService.getBaseModelList(0).subscribe(result => {
      this.baseModelList = result;
    })
  }

  loadUnitNumber() {
    this.selectedUnitNumber = '';
    if (this.CustomerId > 0) {

    } else {
      this.CustomerId = this.multipleSelections.find(x => x.Id == 1).SearchId;
    }

    if (this.JobsiteId > 0) {

    } else {
      var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
      if (jobSiteData != null) {
        if (this.jobsiteCtrl.value != '') {
          this.JobsiteId = jobSiteData.SearchId;
        }
      }
    }

    if (this.make_auto > 0) {
    } else {
      var makeData = this.multipleSelections.find(x => x.Id == 5);
      if (makeData != null) {
        if (this.makeCtrl.value != '') {
          this.make_auto = makeData.SearchId;
        }
      }
    }
    this._interp.GetUnitNo(this.JobsiteId, this.make_auto, this.CustomerId, this.selectedBaseModel).subscribe(result => {
      this.UnitNumberVm = result;
    })
  }
}
